export default __webpack_public_path__ + "static/media/QwVideo.e9ad5e68.mp4";